import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-weight',
    templateUrl: './weight.component.html',
    standalone: false
})
export class InstallationWeightPluginComponent {
  public weights: any[];
  public config: any;
  public editRoute = ['installation', 'weight', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    if (this.config.Weights?.length) {
      this.weights = this.config.Weights;
    } else {
      this.weights = this.config.Weight ? [this.config.Weight] : [];
    }
  }
}
PluginComponent.plugins['installationweight'] = InstallationWeightPluginComponent;
